import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X, LogIn } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { label: 'Home', path: '/' },
    { label: 'Services', path: '/services' },
    { label: 'Online Training', path: '/online-training' },
    { label: 'Corporate', path: '/corporate' },
    { label: 'Retreat', path: '/retreat' },
    { label: 'Results', path: '/results' },
    { label: 'Free Nutrition Advice', path: '/nutrition-guide' },
    { label: 'FAQ', path: '/faq' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location]);

  const handleContactClick = () => {
    navigate('/contact');
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? 'header-scrolled' : ''}`}>
      <div className="container mx-auto px-4">
        <div className="header-content">
          <Link to="/" className="header-logo" data-testid="header-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/oz9nbwu2_Logo.png" 
              alt="AC Wellness & Development" 
              className="logo-image"
            />
          </Link>

          <nav className="desktop-nav" data-testid="desktop-nav">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-link ${location.pathname === item.path ? 'nav-link-active' : ''}`}
                data-testid={`nav-${item.label.toLowerCase()}`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="header-cta-group">
            <Button
              onClick={() => navigate('/portal')}
              className="header-cta-login"
              data-testid="header-portal-btn"
            >
              <LogIn size={16} /> Client Login
            </Button>
            <Button
              onClick={handleContactClick}
              className="header-cta"
              data-testid="header-contact-btn"
            >
              Contact Me
            </Button>
          </div>

          <button
            className="mobile-menu-btn"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
            data-testid="mobile-menu-btn"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        <nav className={`mobile-nav ${isMobileMenuOpen ? 'mobile-nav-open' : ''}`} data-testid="mobile-nav">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`mobile-nav-link ${location.pathname === item.path ? 'mobile-nav-link-active' : ''}`}
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
            >
              {item.label}
            </Link>
          ))}
          <Button
            onClick={() => { navigate('/portal'); setIsMobileMenuOpen(false); }}
            className="mobile-nav-login"
            data-testid="mobile-portal-btn"
          >
            <LogIn size={16} /> Client Login
          </Button>
          <Button
            onClick={handleContactClick}
            className="mobile-nav-cta"
            data-testid="mobile-contact-btn"
          >
            Contact Me
          </Button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
